import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { useScore } from './ScoreContext';
export function StickyWidget() {
  const [isScrolled, setIsScrolled] = useState(false);
  const {
    answeredCount,
    openDiagnostic
  } = useScore();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 800);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isScrolled || answeredCount === 0) return null;
  const title = answeredCount >= 4 ? "You're halfway there" : 'Score started';
  const handleFinishClick = () => {
    openDiagnostic();
  };
  const dots = Array.from({
    length: 8
  });
  return <>
      {/* Desktop card — lower right, paper surface, calm progress cue */}
      <div className="hidden md:flex fixed bottom-8 right-8 z-50 bg-paper text-navy p-5 rounded-2xl shadow-[0_24px_48px_-18px_rgba(26,40,56,0.28)] border border-gray-200/70 flex-col gap-3.5 animate-in slide-in-from-bottom-4 fade-in duration-500 w-[19rem]" data-id="element-556" data-mp="1rlscix37jr3v">
        <div className="flex items-center justify-between gap-4" data-id="element-557" data-mp="36fzcvyujpcsi">
          <div data-id="element-558" data-mp="36hsj5d18xuzz">
            <div className="text-xs font-semibold text-seaglass uppercase tracking-[0.18em] mb-1" data-id="element-559" data-mp="3keyzz22etjmk">
              {title}
            </div>
            <div className="text-sm text-text-muted font-medium" data-id="element-560" data-mp="3fhfmw5hg7cw7">
              {answeredCount} of 8 answered
            </div>
          </div>
          <button type="button" onClick={handleFinishClick} className="flex flex-shrink-0 items-center gap-2 rounded-xl bg-sand px-4 py-2.5 text-sm font-semibold text-navy transition-colors hover:bg-sand-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-seaglass" data-id="element-561" data-mp="2ro764b8th72e">
            Finish <ArrowRight className="h-4 w-4" aria-hidden="true" data-id="element-562" data-mp="2wnjskuvs0c4g" />
          </button>
        </div>
        {/* Segmented sea-glass progress cue — no ring, no meter */}
        <div className="flex items-center gap-1.5" data-id="element-563" data-mp="23zxntjatb1g0">
          {dots.map((_, i) => <div key={i} className={`h-1.5 flex-1 rounded-full ${i < answeredCount ? 'bg-seaglass' : 'bg-gray-200'}`} data-id="element-564" data-mp="7ycgy6ge5idk" data-mpi={i}>
          </div>)}
        </div>
      </div>

      {/* Mobile bottom bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-paper text-navy px-4 py-3 shadow-[0_-10px_30px_rgba(26,40,56,0.12)] border-t border-gray-200/70 flex items-center justify-between animate-in slide-in-from-bottom-full duration-300" data-id="element-565" data-mp="hnw2jjvhnqc4">
        <div className="flex items-center gap-2 text-sm" data-id="element-566" data-mp="3l5xikgb407dd">
          <span className="font-semibold" data-id="element-567" data-mp="3q2xo8q41r83y">Score</span>
          <span className="text-gray-300" data-id="element-568" data-mp="3q5jtuk7dndjj">&middot;</span>
          <span className="text-seaglass font-semibold" data-id="element-569" data-mp="3u3zmb3m89e4c">{answeredCount}/8</span>
        </div>
        <button type="button" onClick={handleFinishClick} className="flex min-h-[44px] items-center gap-1.5 rounded-lg bg-sand px-4 py-2 text-sm font-semibold text-navy transition-colors hover:bg-sand-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-seaglass" data-id="element-570" data-mp="2yztpklly9ag">
          Finish <ArrowRight className="h-3.5 w-3.5" aria-hidden="true" data-id="element-571" data-mp="1oid0xuiquros" />
        </button>
      </div>
    </>;
}